import type {
  QuartileEvent,
  WebediaPlayer
} from '@webedia-services/webedia-player';

import type { PlayerCustomData } from 'website/module/player';
import { getCurrentCustomData } from 'website/tracking/player/utils';

import { GTMItemData, pushDatalayer } from './gtm.internals';

// here we define all the variables to send to dataLayer depending on the player state
const commonTagForDataLayout: { [key: string]: string[] } = {
  'video-content': [
    'clicked_movie_id',
    'clicked_movie_label',
    'clicked_series_id',
    'clicked_series_label',
    'clicked_video_id',
    'clicked_video_label',
    'movie_distributor',
    'series_distributor'
  ]
};

/**
 * A helper for quartiles / playing tracking as it is almost the same
 * for pre-roll, content and advertising
 * @param {QuartileEvent} event
 * @param {String} playerState the player state to determine which dimensions to use
 * @param {PlayerCustomData} customData
 * @return {void}
 */
const quartileEventTracking = (
  { detail: { quartile } }: QuartileEvent,
  playerState: string,
  customData: PlayerCustomData
) => {
  const baseDataLayout = {
    event: 'event',
    eventCategory: playerState,
    dataLayerVariables: commonTagForDataLayout[playerState]
  };

  const hits: GTMItemData[] = [];
  if (quartile === 0) {
    hits.push({
      ...baseDataLayout,
      action: 'starts'
    });
  } else if (quartile < 4) {
    hits.push({
      ...baseDataLayout,
      action: `play-${quartile * 25}`
    }); // convert quartile (1 2 3) to percentile (25 50 75))
  } else {
    hits.push({
      ...baseDataLayout,
      action: 'finish'
    });
  }

  hits.forEach(item => pushDatalayer(item, customData));
};

const initGtm = (
  webediaPlayer: WebediaPlayer,
  customData: PlayerCustomData
) => {
  webediaPlayer.addEventListener('quartile', event => {
    const currentCustomData = getCurrentCustomData(customData, webediaPlayer);
    quartileEventTracking(event, 'video-content', currentCustomData);
  });
};

export default initGtm;
